module.exports = __webpack_public_path__ + "static/servicedOffice-25994a4324e88196b6fc1a79a054b5db.jpg";